import React from 'react';
import { useAssessment } from '@/contexts/AssessmentContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/shared/card';
import { Button } from '@/components/shared/button';
import { Badge } from '@/components/shared/badge';
import { Separator } from '@/components/shared/separator';
import { ScrollArea } from '@/components/shared/scroll-area';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/shared/tooltip';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/shared/table';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useNavigate } from 'react-router-dom';
import { normalizeScores } from '@/utils/normalization';
import OpportunityRow from './opportunities/OpportunityRow';

const RankedList = () => {
  const { scoredOpportunities } = useAssessment();
  console.log('Scored Opportunities:', scoredOpportunities);

  const normalizedOpportunities = normalizeScores(scoredOpportunities);
  
  // Sort by final score (60% value, 40% feasibility)
  const sortedOpportunities = [...normalizedOpportunities].sort(
    (a, b) => ((b.valueScore * 0.6 + b.feasibilityScore * 0.4)) - ((a.valueScore * 0.6 + a.feasibilityScore * 0.4))
  );

  return (
    <Card className="p-6 bg-white border border-gray-200 shadow-sm">
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-gray-50/50">
            <TableHead className="w-[80px] font-semibold text-gray-700 align-top text-left">Rank</TableHead>
            <TableHead className="font-semibold text-gray-700 align-top text-left">Opportunity</TableHead>
            <TableHead className="w-[120px] font-semibold text-gray-700 align-top text-left">Value Score</TableHead>
            <TableHead className="w-[140px] font-semibold text-gray-700 align-top text-left">Feasibility Score</TableHead>
            <TableHead className="w-[120px] font-semibold text-gray-700 align-top text-left">Final Score</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sortedOpportunities.map((opportunity, index) => (
            <OpportunityRow 
              key={opportunity.Name}
              opportunity={opportunity}
              index={index}
            />
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default RankedList;